import React, { useState, useEffect, useRef } from "react";
import { SideBar } from "../../../../imports";
import pdfIcon from "../../../../assets/icons/Pdf Icon.png";
import { ObtenerFormularios } from "../../../../servicios/ServicioFormulario";
import { ObtenerPersonasCV } from "../../../../servicios/ServicioPersonaCV";
import { ObtenerReporteEvaluacion } from "../../../../servicios/ServicioEvaluacion";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Select from "react-select";
import PdfReporteEvaluacion from "./PdfReporteEvaluacion";
import { pdf } from "@react-pdf/renderer";
export default function ReporteEvaluaciones() {
    const [formularios, setFormularios] = useState([]);
    const [personas, setPersonas] = useState([]);
    const [idFormulario, setIdFormulario] = useState("");
    const [idEvaluado, setIdEvaluado] = useState("");
    const [reporte, setReporte] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [modal, setModal] = useState({ visible: false, tipo: "info", titulo: "", mensaje: "" });
    const [paginaActual, setPaginaActual] = useState(1);
    const [ordenAscendente, setOrdenAscendente] = useState(true);
    const elementosPorPagina = 10;
    const contenedorPDF = useRef(null);

    const mostrarModal = (tipo, titulo, mensaje) => setModal({ visible: true, tipo, titulo, mensaje });
    const cerrarModal = () => setModal({ ...modal, visible: false });

    useEffect(() => {
        cargarFormularios();
        cargarPersonas();
    }, []);

    const cargarFormularios = async () => {
        try {
            const data = await ObtenerFormularios();
            const activos = (data || []).filter((f) => f.Activo || f.activo);
            setFormularios(activos);
        } catch (err) {
            console.error("❌ Error cargando formularios:", err);
        }
    };

    const cargarPersonas = async () => {
        try {
            const response = await ObtenerPersonasCV();
            const normalizadas = (response || [])
                .filter(p => p.TrabajaEnRossmon === 1 || p.trabajaEnRossmon === 1)
                .map((p) => ({
                    idPersona: p.idPerson ?? p.IdPersona,
                    nombre: p.nombre ?? p.NombreCompleto ?? p.Nombre ?? "Sin nombre",
                    especializacion: p.nombreEspecializacion ?? p.NombreEspecializacion ?? "",
                }));
            setPersonas(normalizadas);
        } catch (error) {
            console.error("❌ Error al obtener personas:", error);
            setPersonas([]);
        }
    };

    const generarReporte = async () => {
        if (!idFormulario) return mostrarModal("error", "Error", "Seleccione un formulario.");
        if (!idEvaluado) return mostrarModal("error", "Error", "Seleccione una persona evaluada.");

        try {
            setCargando(true);
            const result = await ObtenerReporteEvaluacion(idFormulario, idEvaluado);
            if (!Array.isArray(result) || result.length === 0) {
                mostrarModal("info", "Sin resultados", "No hay registros para los parámetros seleccionados.");
                setReporte([]);
                return;
            }
            setReporte(result);
            setPaginaActual(1);
        } catch (err) {
            console.error("❌ Error generando reporte:", err);
            mostrarModal("error", "Error", "No se pudo generar el reporte.");
        } finally {
            setCargando(false);
        }
    };

    
    const likert = reporte.filter((r) => r.tipoPregunta?.toLowerCase() === "likert");
    const siNo = reporte.filter((r) =>
        r.tipoPregunta?.toLowerCase() === "sino" || r.tipoPregunta?.toLowerCase() === "sí/no"
    );

    
    const promedioGeneralLikert = (() => {
        const valores = likert
            .map((r) => parseFloat(r.respuesta))
            .filter((v) => !isNaN(v));
        if (valores.length === 0) return 0;
        return (valores.reduce((a, b) => a + b, 0) / valores.length).toFixed(2);
    })();

    
    const conteoSiNo = (() => {
        let si = 0, no = 0;
        siNo.forEach((r) => {
            const resp = r.respuesta?.toLowerCase();
            if (resp === "si" || resp === "sí") si++;
            else if (resp === "no") no++;
        });
        const total = si + no;
        return {
            si,
            no,
            porcentajeSi: total === 0 ? 0 : (si / total) * 100,
            porcentajeNo: total === 0 ? 0 : (no / total) * 100,
        };
    })();

    const reporteOrdenado = [...reporte].sort((a, b) =>
        ordenAscendente ? a.pregunta.localeCompare(b.pregunta) : b.pregunta.localeCompare(a.pregunta)
    );

    const totalPaginas = Math.ceil(reporteOrdenado.length / elementosPorPagina);

    const cambiarOrden = () => setOrdenAscendente(!ordenAscendente);

    const descargarPDF = async () => {
        try {
            const persona = personas.find((p) => p.idPersona === idEvaluado);
            const formulario = formularios.find((f) => f.idFormulario === idFormulario);

            const blob = await pdf(
                <PdfReporteEvaluacion
                    persona={persona}
                    formulario={formulario}
                    respuestas={reporte}
                />
            ).toBlob();

            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            link.download = `Reporte_${persona?.nombre ?? "Evaluado"}.pdf`;
            link.click();
        } catch (error) {
            
            mostrarModal("error", "Error", "No se pudo descargar el PDF.");
        }
    };

    return (
        <div className="flex flex-row min-h-screen bg-gradient-to-br from-gray-50 to-emerald-50">
            <div className="md:basis-1/4 xl:basis-1/5">
                <SideBar />
            </div>

            <div className="md:basis-3/4 xl:basis-11/12 p-8" ref={contenedorPDF}>
                <div className="bg-white rounded-3xl shadow-xl px-10 py-10 border border-gray-100">
                    
                    <h1 className="text-3xl font-bold text-emerald-700 mb-2">Reporte de Evaluaciones</h1>
                    <p className="text-gray-600 mb-8 text-sm">
                        Seleccione un formulario y una persona evaluada para visualizar los resultados.
                    </p>

                    
                    <div className="flex flex-col md:flex-row gap-4 mb-8 items-end">
                        
                        <div className="flex-1 flex flex-col justify-end">
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase tracking-wide">
                                Persona evaluada
                            </label>

                            <Select
                                options={personas.map((p) => ({ value: p.idPersona, label: p.nombre }))}
                                value={personas.find((p) => p.idPersona === idEvaluado)
                                    ? { value: idEvaluado, label: personas.find(p => p.idPersona === idEvaluado).nombre }
                                    : null}
                                onChange={(selected) => setIdEvaluado(selected ? selected.value : "")}
                                placeholder="Seleccione..."
                                isClearable
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        minHeight: "48px",
                                        borderRadius: "1rem",
                                    }),
                                }}
                            />
                        </div>

                        
                        <div className="flex-1 flex flex-col justify-end">
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase tracking-wide">
                                Formulario
                            </label>

                            <Select
                                options={formularios.map((f) => ({ value: f.idFormulario, label: f.nombre }))}
                                value={formularios.find((f) => f.idFormulario === idFormulario)
                                    ? { value: idFormulario, label: formularios.find(f => f.idFormulario === idFormulario).nombre }
                                    : null}
                                onChange={(selected) => setIdFormulario(selected ? selected.value : "")}
                                placeholder="Seleccione..."
                                isClearable
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        minHeight: "48px",
                                        borderRadius: "1rem",
                                    }),
                                }}
                            />
                        </div>

                        
                        <button
                            onClick={generarReporte}
                            disabled={cargando}
                            className="
                                w-full md:w-auto
                                h-[48px]
                                px-4
                                bg-emerald-600
                                text-white 
                                text-base 
                                font-semibold 
                                rounded-2xl
                                hover:bg-emerald-700
                                transition
                                shadow-lg
                                flex items-center justify-center
                            "
                        >
                            {cargando ? "Buscando..." : "🔍"}
                        </button>
                    </div>

                    
                    <div className="flex justify-between mb-10">
                        <button
                            onClick={cambiarOrden}
                            className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 text-gray-700 font-semibold transition"
                        >
                            Ordenar {ordenAscendente ? "↓" : "↑"}
                        </button>

                        {reporte.length > 0 && (
                            <button
                                onClick={descargarPDF}
                                className="
            px-6
        py-3
        rounded-2xl
        transition shadow-lg
        flex items-center justify-center gap-2
        bg-gray-900 text-white hover:bg-black
        disabled:opacity-60 disabled:cursor-not-allowed
        "
                                title="Descargar PDF"
                            >
                                <img
                                    src={pdfIcon}
                                    alt="PDF"
                                    className="w-5 h-5 object-contain"
                                />
                                <span className="font-semibold">
                                    {descargarPDF ? "Descargar PDF" : "Descargar PDF"}
                                </span>
                            </button>
                        
                    )}

                    </div>

                    
                    {reporte.length > 0 && (
                        <>
                            <div className="overflow-x-auto border border-gray-200 rounded-2xl shadow-sm mb-6">
                                <table className="min-w-full divide-y divide-gray-200 text-sm">
                                    <thead className="bg-emerald-600 text-white">
                                        <tr>
                                            <th className="px-6 py-3 text-left font-semibold">Pregunta</th>
                                            <th className="px-6 py-3 text-left font-semibold">Tipo</th>
                                            <th className="px-6 py-3 text-left font-semibold">Respuesta</th>
                                            <th className="px-6 py-3 text-left font-semibold">Fecha</th>
                                        </tr>
                                    </thead>

                                    <tbody className="bg-white divide-y divide-gray-100">
                                        {reporte
                                            .slice((paginaActual - 1) * elementosPorPagina, paginaActual * elementosPorPagina)
                                            .map((r, i) => (
                                                <tr key={i} className="hover:bg-emerald-50 transition">
                                                    <td className="px-6 py-4">{r.pregunta}</td>
                                                    <td className="px-6 py-4 capitalize">{r.tipoPregunta}</td>
                                                    <td
                                                        className="px-6 py-4 break-words whitespace-pre-wrap max-w-xs"
                                                    >
                                                        {r.respuesta}
                                                    </td>

                                                    <td className="px-6 py-4">{r.fechaCreacion}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>

                            
                            <div className="flex justify-center items-center space-x-2 mb-8">
                                {Array.from({ length: totalPaginas }).map((_, i) => (
                                    <button
                                        key={i}
                                        onClick={() => setPaginaActual(i + 1)}
                                        className={`px-3 py-1 rounded-md text-sm font-medium transition ${paginaActual === i + 1
                                                ? "bg-emerald-600 text-white shadow"
                                                : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                                            }`}
                                    >
                                        {i + 1}
                                    </button>
                                ))}
                            </div>
                        </>
                    )}

                    
                    {likert.length > 0 && (
                        <div className="mt-14">
                            <h3 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-2 border-emerald-200">
                                Escala Likert – Promedio global
                            </h3>

                            {(() => {
                                const valor = parseFloat(promedioGeneralLikert);
                                let backgroundGrad = "";
                                if (valor >= 4) backgroundGrad = "linear-gradient(to right, #10B981, #047857)";
                                else if (valor >= 3) backgroundGrad = "linear-gradient(to right, #FACC15, #EAB308)";
                                else backgroundGrad = "linear-gradient(to right, #EF4444, #B91C1C)";

                                return (
                                    <div className="p-5 rounded-2xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition w-64 mb-10">
                                        <div className="flex justify-between items-center mb-3">
                                            <h4 className="font-semibold text-gray-700">Promedio global</h4>
                                            <span
                                                className="px-3 py-1 text-sm font-bold text-white rounded-full"
                                                style={{ background: backgroundGrad }}
                                            >
                                                {promedioGeneralLikert}
                                            </span>
                                        </div>

                                        <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
                                            <div
                                                className="h-4 rounded-full transition-all duration-700 ease-in-out"
                                                style={{ width: `${(valor / 5) * 100}%`, background: backgroundGrad }}
                                            ></div>
                                        </div>
                                    </div>
                                );
                            })()}

                            
                            <h3 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-2 border-emerald-200">
                                Escala Likert – Promedio por pregunta
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {likert.map((r, i) => {
                                    const valor = parseFloat(r.respuesta);
                                    const porcentaje = (valor / 5) * 100;

                                    let backgroundGrad = "";
                                    if (valor >= 4) backgroundGrad = "linear-gradient(to right, #10B981, #047857)";
                                    else if (valor >= 3) backgroundGrad = "linear-gradient(to right, #FACC15, #EAB308)";
                                    else backgroundGrad = "linear-gradient(to right, #EF4444, #B91C1C)";

                                    return (
                                        <div key={i} className="p-5 rounded-2xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition">
                                            <div className="flex justify-between items-center mb-3">
                                                <h4 className="font-semibold text-gray-700">{r.pregunta}</h4>
                                                <span
                                                    className="px-3 py-1 text-sm font-bold text-white rounded-full"
                                                    style={{ background: backgroundGrad }}
                                                >
                                                    {valor.toFixed(2)}
                                                </span>
                                            </div>

                                            <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
                                                <div
                                                    className="h-4 rounded-full transition-all duration-700 ease-in-out"
                                                    style={{ width: `${porcentaje}%`, background: backgroundGrad }}
                                                ></div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    
                    {conteoSiNo.si + conteoSiNo.no > 0 && (
                        <div className="mt-16 text-center">
                            <h3 className="text-2xl font-bold text-gray-800 mb-6">
                                Distribución de respuestas (Sí/No)
                            </h3>

                            <div className="flex flex-col md:flex-row items-center justify-center gap-10">

                                
                                <div className="w-80 bg-white p-6 rounded-xl shadow-md border">

                                    
                                    <div className="mb-6">
                                        <div className="flex justify-between mb-1">
                                            <span className="font-semibold text-emerald-700">Sí</span>
                                            <span className="font-semibold text-emerald-700">
                                                {conteoSiNo.porcentajeSi.toFixed(0)}%
                                            </span>
                                        </div>

                                        <div className="w-full bg-gray-200 rounded-full h-5 overflow-hidden">
                                            <div
                                                className="h-5 rounded-full bg-emerald-500 transition-all duration-700"
                                                style={{ width: `${conteoSiNo.porcentajeSi}%` }}
                                            ></div>
                                        </div>
                                    </div>

                                    
                                    <div>
                                        <div className="flex justify-between mb-1">
                                            <span className="font-semibold text-red-600">No</span>
                                            <span className="font-semibold text-red-600">
                                                {conteoSiNo.porcentajeNo.toFixed(0)}%
                                            </span>
                                        </div>

                                        <div className="w-full bg-gray-200 rounded-full h-5 overflow-hidden">
                                            <div
                                                className="h-5 rounded-full bg-red-500 transition-all duration-700"
                                                style={{ width: `${conteoSiNo.porcentajeNo}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>

                                
                                <div className="text-sm bg-gray-50 p-5 rounded-xl shadow-inner border border-gray-200 w-72">
                                    <table className="w-full text-left">
                                        <thead className="text-gray-600">
                                            <tr>
                                                <th className="pb-2">Pregunta</th>
                                                <th className="pb-2">Respuesta</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {siNo.map((q, i) => (
                                                <tr key={i} className="border-t border-gray-200">
                                                    <td className="py-2 pr-2 text-gray-700">{q.pregunta}</td>
                                                    <td
                                                        className={`py-2 font-semibold ${q.respuesta.toLowerCase() === "si" || q.respuesta.toLowerCase() === "sí"
                                                                ? "text-emerald-600"
                                                                : "text-red-500"
                                                            }`}
                                                    >
                                                        {q.respuesta}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    )}
                </div>
            </div>

            
            {modal.visible && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
                    onClick={cerrarModal}
                >
                    <div
                        className="bg-white rounded-2xl shadow-xl w-[520px] max-w-[92vw] relative overflow-hidden"
                        onClick={(e) => e.stopPropagation()}
                    >
                        
                        <div className="absolute left-0 top-0 bottom-0 w-2 bg-[#EF4444]" />

                        <div className="p-10 text-center">
                            
                            <div className="flex justify-center mb-5">
                                <div className="w-16 h-16 rounded-full border-4 border-[#EF4444] flex items-center justify-center">
                                    <span className="text-[#EF4444] text-4xl font-bold leading-none">×</span>
                                </div>
                            </div>

                            
                            <h2 className="text-2xl font-bold text-[#EF4444] mb-3">
                                {modal.titulo || "Aviso"}
                            </h2>

                            
                            <p className="text-gray-700 text-lg leading-relaxed mb-8 whitespace-pre-line">
                                {modal.mensaje}
                            </p>

                            
                            <button
                                onClick={cerrarModal}
                                className="px-10 py-3 rounded-xl bg-[#EF4444] text-white font-semibold shadow-md hover:bg-[#DC2626] transition"
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
